module.exports = __webpack_public_path__ + "img/emplois-assurance-courtage.14e68b13.svg";